const basePath = 'server';

export const env: string = 'RELEASE';

export const environment = {
  production: true,

  xsrfTokenCookie: 'XSRF-SA-TOKEN',
  xsrfTokenHeader: 'X-XSRF-SA-TOKEN',

  urlBase: 'https://localhost/',
  welcomeRoute: 'welcome',

  loginEndpoint: `${basePath}/auth/login`,
  logoutEndpoint: `${basePath}/auth/logout`,

  userListEndpoint: `${basePath}/admin/user-list/`,
  userCreateEndpoint: `${basePath}/admin/create-user`,
  userDetailLookupEndpoint: `${basePath}/admin/user-lookup/`,
  userDetailLookupUpdateBasicInfoEndpoint: `${basePath}/admin/user-lookup/update/basic-info`,
  userDetailLookupUpdateContactInfoEndpoint: `${basePath}/admin/user-lookup/update/contact-info`,
  userDetailLookupUpdateCustomersInfoEndpoint: `${basePath}/admin/user-lookup/update/customers-info`,
  userDetailLookupUpdateFacilitiesInfoEndpoint: `${basePath}/admin/user-lookup/update/facilities-info`,
  userDetailLookupUpdateReportsInfoEndpoint: `${basePath}/admin/user-lookup/update/reports-info`,
  userResetPasswordEndpoint: `${basePath}/admin/user-lookup/update/password`,

  customerListEndpoint: `${basePath}/customer/list/`,
  infoEndpoint: `${basePath}/data/info/`,
  getImageEndpoint: `${basePath}/data/get-image/`,
  uploadImageEndpoint: `${basePath}/data/upload-image`,
  deleteImageEndpoint: `${basePath}/data/delete-image`,
  errorReportEndpoint: `${basePath}/data/error-report`,

  inventoryFcpiEndpoint: `${basePath}/inventory/inquiry/fcpi`,
  inventoryItemDetailEndpoint: `${basePath}/inventory/inquiry/item-detail`,
  inventoryItemLotRequiredVal: `${basePath}/inventory/inquiry/item-lot-required`,
  inventoryItemLotEndpoint: `${basePath}/inventory/inquiry/item-lot`,
  listEndpoint: `${basePath}/utility/list/`,

  orderInquiryEndpoint: `${basePath}/orders/inquiry/qualifiers`,
  orderInquiryHeaderEndpoint: `${basePath}/orders/inquiry/header`,
  orderCreateInboundHeaderEndpoint: `${basePath}/orders/create/inbound-header`,
  orderCreateOutboundHeaderEndpoint: `${basePath}/orders/create/outbound-header`,
  orderCancelHeaderEndpoint: `${basePath}/orders/update/cancel-order`,
  orderUpdateHeaderEndpoint: `${basePath}/orders/update/header`,
  orderUpdateDetailEndpoint: `${basePath}/orders/update/detail`,
  orderBulkUpdateDetailEndpoint: `${basePath}/orders/update/detail-bulk`,
  orderDeleteItemDetailEndpoint: `${basePath}/orders/update/detail/delete`,
  orderInquiryDetailsEndpoint: `${basePath}/orders/inquiry/details`,
  orderGetAttachment: `${basePath}/orders/inquiry/get-order-attachment`,
  orderGetItemUOMS: `${basePath}/orders/inquiry/get-item-uoms`,
  orderGetItems: `${basePath}/orders/inquiry/items`,
  orderGetItemLots: `${basePath}/orders/inquiry/get-item-lots`,
  orderShippingDetails: `${basePath}/orders/inquiry/shipping-details`,
  orderLock: `${basePath}/orders/update/lock-order`,
  orderDuplicateRefPoCheck: `${basePath}/orders/inquiry/duplicate-ref-po-check`,
  orderFilterStore: `${basePath}/data/store`,

  reportListEndpoint: `${basePath}/reports/list/`,
  reportGetParametersEndpoint: `${basePath}/reports/get-params`,
  reportSetParametersEndpoint: `${basePath}/reports/set-params`,
  reportGenerateEndpoint: `${basePath}/reports/generate`,
  reportDownloadEndpoint: `${basePath}/reports/download`,
  reportRefreshEndpoint: `${basePath}/reports/refresh`,

  changeCustomerEndpoint: `${basePath}/user/change-customer`,
  changeFacilityEndpoint: `${basePath}/user/change-facility`,

  preloadLists: ['facility', 'customer', 'shipmenttypes'],
  customerPreloadLists: ['product-groups', 'items', 'shipto', 'billto', 'passthru-labels'],
};

export const credentials = {
  username: '',
  password: '',
};
